import { maxLength, ValidationField, Validator } from "~/extensions/utils";
export class RoomSelectFindConditionValidator extends Validator {
    constructor(vm) {
        const constraints = {
            keyword: {
                length: maxLength(40)
            }
        };
        super(vm, constraints);
        this.keyword = new ValidationField("keyword", this.data, constraints);
    }
    keyword;
}
